/* Nyeleti fixes that must not live in theme-v2.js.

   theme-v2.js is served truncated: a marker written at byte 0 arrives, but
   anything past roughly 55KB does not, so features appended to that file were
   pushed successfully and never ran. These two live here instead, in a file
   small enough to arrive whole.

   1. Swatch -> photograph of that colour, matched from the pixels.
   2. Product card / gallery image fit, decided per photograph.
*/
(function () {
  'use strict';
  window.__NYELETI_FIXES = 'loaded';

  function ready(fn) {
    if (document.readyState === 'complete') fn();
    else window.addEventListener('load', fn);
  }

  /* ---------------------------------------------------------------------
     Search.

     Rewritten to own its own overlay rather than drive the theme's.

     The sheet in `site-overlays.liquid` is positioned entirely by Tailwind
     utilities — `fixed inset-x-0 top-0 z-[70]`, parked with `-translate-y-full`
     and revealed by an `.is-open` rule. This theme ships a PURGED Tailwind
     bundle and those rules are not in it, so the sheet had no `position`, no
     `z-index` and no transform to undo: it sat in normal flow underneath the
     footer. Every previous fix here was an attempt to out-specify rules that do
     not exist, and the last one — a MutationObserver on the panel's class, put
     there to catch the other bundle opening it — locked the renderer when both
     scripts toggled the same class on one click, which is the freeze that
     looked like "glitching".

     So this no longer touches that panel at all. It builds its own overlay,
     styles every property inline where nothing can purge or outrank it, and
     binds every search button on the page, which is what makes it work on a
     phone as well as on a desktop.
     ------------------------------------------------------------------- */
  function wireSearch() {
    if (document.documentElement.hasAttribute('data-nyeleti-search')) return;
    document.documentElement.setAttribute('data-nyeleti-search', '1');

    /* The theme's own sheet is left inert so it can never appear under the
       footer or fight this one for the same click. */
    var legacy = document.querySelector('[aria-label="Search products"]');
    if (legacy) {
      legacy.setAttribute('aria-hidden', 'true');
      legacy.style.setProperty('display', 'none', 'important');
    }

    function css(el, decls) {
      for (var k in decls) {
        if (Object.prototype.hasOwnProperty.call(decls, k)) {
          el.style.setProperty(k, decls[k], 'important');
        }
      }
    }

    var wrap = document.createElement('div');
    wrap.setAttribute('data-nyeleti-search-overlay', '');
    css(wrap, {
      position: 'fixed', inset: '0px', 'z-index': '2147483000',
      display: 'none', background: 'rgba(12,17,35,.55)'
    });

    var sheet = document.createElement('div');
    css(sheet, {
      position: 'absolute', top: '0px', left: '0px', right: '0px',
      background: '#fff', padding: '18px 20px 22px',
      'box-shadow': '0 24px 60px rgba(20,26,50,.22)',
      'max-height': '86vh', 'overflow-y': 'auto'
    });
    wrap.appendChild(sheet);

    var bar = document.createElement('form');
    bar.setAttribute('action', '/search');
    bar.setAttribute('method', 'get');
    bar.setAttribute('role', 'search');
    css(bar, {
      display: 'flex', 'align-items': 'center', gap: '12px',
      'border-bottom': '1px solid rgba(20,26,50,.16)', 'padding-bottom': '12px',
      margin: '0px', 'max-width': '1180px', 'margin-left': 'auto',
      'margin-right': 'auto'
    });

    var field = document.createElement('input');
    field.type = 'search';
    field.name = 'q';               /* Shopify's results page reads `q`. */
    field.autocomplete = 'off';
    field.placeholder = 'Search products, collections…';
    field.setAttribute('aria-label', 'Search products');
    css(field, {
      flex: '1 1 auto', border: '0px', outline: 'none', background: 'transparent',
      font: 'inherit', 'font-size': '18px', color: '#141a32', 'min-height': '44px',
      /* iOS zooms the page in on focus for anything under 16px. */
      '-webkit-appearance': 'none'
    });

    var close = document.createElement('button');
    close.type = 'button';
    close.setAttribute('aria-label', 'Close search');
    close.textContent = '✕';
    css(close, {
      border: '0px', background: 'transparent', cursor: 'pointer',
      'font-size': '20px', color: '#141a32', 'min-width': '44px',
      'min-height': '44px', 'line-height': '1'
    });

    bar.appendChild(field);
    bar.appendChild(close);
    sheet.appendChild(bar);

    var results = document.createElement('div');
    css(results, {
      'max-width': '1180px', margin: '14px auto 0', display: 'grid',
      gap: '4px'
    });
    sheet.appendChild(results);

    function open() {
      css(wrap, { display: 'block' });
      document.documentElement.style.setProperty('overflow', 'hidden');
      /* iOS will not move focus without a real frame in between. */
      window.setTimeout(function () { field.focus(); }, 30);
    }

    function shut() {
      css(wrap, { display: 'none' });
      document.documentElement.style.removeProperty('overflow');
      results.innerHTML = '';
      field.value = '';
    }

    close.addEventListener('click', shut);
    wrap.addEventListener('click', function (e) {
      if (e.target === wrap) shut();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') shut();
    });

    /* Every search control on the page, not just the first. The header renders
       one for desktop and the mobile menu renders another, and binding only
       `querySelector` left the phone's button dead. */
    function bindButtons() {
      var buttons = document.querySelectorAll(
        'button[aria-label="Search"], [data-search-toggle], a[href="/search"]'
      );
      Array.prototype.forEach.call(buttons, function (b) {
        if (b.__nyeletiSearch) return;
        b.__nyeletiSearch = true;
        b.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          open();
        });
      });
      return buttons.length;
    }
    bindButtons();
    /* The mobile drawer builds its markup when it is first opened, so its
       button does not exist at load. Re-bind when the DOM grows. */
    if (window.MutationObserver) {
      new MutationObserver(function () { bindButtons(); })
        .observe(document.body, { childList: true, subtree: true });
    }

    function esc(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    var timer = null;
    var seq = 0;
    field.addEventListener('input', function () {
      var q = field.value.trim();
      window.clearTimeout(timer);
      /* One character is enough. It used to wait for two, so tapping search
         and typing a single letter left a blank panel with no feedback -
         which reads as "suggestions are broken" rather than "keep typing".
         The 140ms debounce below still keeps this to one request per pause. */
      if (!q.length) { results.innerHTML = ''; return; }
      timer = window.setTimeout(function () {
        var mine = ++seq;
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
                  '&resources[type]=product,collection,page' +
                  '&resources[limit]=8&resources[options][unavailable_products]=show';
        window.fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (j) {
            /* A slow reply for an earlier keystroke must not overwrite a newer
               one, so each request carries its turn and stale ones are dropped. */
            if (mine !== seq) return;
            var res = (j.resources || {}).results || {};
            var items = (res.products || [])
              .concat(res.collections || [])
              .concat(res.pages || []);
            if (!items.length) {
              results.innerHTML = '<p style="font-size:14px;color:#5a6178;margin:8px 0">' +
                'No matches for &ldquo;' + esc(q) + '&rdquo;.</p>';
              return;
            }
            results.innerHTML = items.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
              /* The predictive endpoint already returns the price in rands,
                 not in cents the way the cart and product APIs do. Dividing by
                 a hundred turned R799.00 into R7.99. */
              var price = p.price ? '<span style="margin-left:auto;font-size:13px;color:#5a6178">R ' +
                Number(p.price).toFixed(2) + '</span>' : '';
              return '<a href="' + esc(p.url) + '" style="display:flex;align-items:center;' +
                'gap:12px;padding:8px 4px;text-decoration:none;color:#141a32;' +
                'border-radius:8px">' +
                (img ? '<img src="' + esc(img) + '" alt="" style="height:48px;width:48px;' +
                  'flex:0 0 auto;object-fit:contain;background:#f2f3f7;border-radius:6px">' : '') +
                '<span style="font-size:14px">' + esc(p.title) + '</span>' + price + '</a>';
            }).join('');
          })
          .catch(function () {
            if (mine !== seq) return;
            results.innerHTML = '<p style="font-size:14px;color:#5a6178;margin:8px 0">' +
              'Search is unavailable just now.</p>';
          });
      }, 140);
    });

    bar.addEventListener('submit', function () {
      /* Let the form submit to /search?q=… natively. */
      if (!field.value.trim()) return false;
    });

    document.body.appendChild(wrap);
  }

  /* ---------------------------------------------------------------------
     Card image fit, decided per photograph.

     The stylesheet defaults every card image to `contain`, so nothing is ever
     cut. That is right for a square studio render or a tall portrait in a 3/4
     box, but it leaves a visible band on a photograph that is only a hair off
     the frame — and most of the catalogue is shot 1200x1600, exactly 3/4.

     So each image is measured against its own frame once it has loaded, and
     promoted back to `cover` when filling would cost less than a twentieth of
     the picture. Both frames of a card are treated separately: the hover shot is
     usually a different shape from the one at rest, which is why a single rule
     for the pair always cut one of them.
     --------------------------------------------------------------------- */
  var FIT_SEL = [
    '[data-product-image] img',
    '.product-card__photos img',
    '[data-product-grid] img',
    '[data-product-card] img',
    'article .aspect-\\[3\\/4\\] img'
  ].join(',');

  /* Fraction of a photograph we will let `cover` eat. 0.30 clears the 2:3
     studio portraits (11% off the 3/4 card); landscape group shots are 50% off
     and keep their whole frame. Studio renders do not use this — they crop only
     into their measured plain ground, see theme-v3.js. */
  var CROP_ALLOWANCE = 0.30;

  /* How much of a photograph a card may trim away before it is shown whole
     instead. A seventh reads as no crop at all on the shelf. */
  var FILL_COST = 0.15;

  /* How far a landscape photograph is pushed into its card once it is being
     shown whole. Taken from the Fashion Week Golfer: 4734x5259 against a 3/4
     card is a 1.21 zoom, and that is the card being used as the reference. */
  var LANDSCAPE_ZOOM = 1.45;

  function groundEntry(img) {
    var map = window.NYELETI_GROUND;
    if (!map) return null;
    var src = img.currentSrc || img.src || '';
    return map[src.split('?')[0].split('/').pop()] || null;
  }

  /* Returns true only when the picture was actually measured and a fit applied.
     The caller needs to know the difference: an image that could not be measured
     has to be looked at again, not written off. */
  function decideFit(img) {
    if (!img.naturalWidth || !img.naturalHeight) return false;
    var box = img.parentElement;
    while (box && box.clientHeight === 0) box = box.parentElement;
    if (!box || !box.clientWidth || !box.clientHeight) return false;

    var frame = box.clientWidth / box.clientHeight;
    var shot = img.naturalWidth / img.naturalHeight;
    var wide = shot > frame;
    /* How much of the picture `cover` would push outside the frame. */
    var loss = wide ? 1 - frame / shot : 1 - shot / frame;
    var entry = groundEntry(img);
    var ceiling = entry ? (wide ? entry[0] : entry[1]) : null;
    /* Landscape photographs fill rather than letterbox — see theme-v3.js. */
    var allowed;
    if (ceiling === null || ceiling === undefined) {
      /* No measured ground for this file. That is not a rare case any more:
         the map is keyed by filename, and every photograph swapped in since it
         was built carries a new name, so those all landed here and the 0.30
         allowance cropped them — which is the cutting that came back on the
         product rails. An unmeasured upright photograph is therefore shown
         whole; only landscape frames, which letterbox badly in an upright card
         and have room to spare at the sides, are still allowed to fill. */
      allowed = shot > 1.02 ? 0.55 : 0;
    } else {
      allowed = ceiling;
    }
    /* Fill the card only where filling costs nothing.

       `entry` records how much of each axis of this photograph is plain ground.
       Where the card's crop stays inside that margin the picture fills the frame
       and no garment is touched. Where it would reach past it -- or where the
       file has no measurement, which is every photograph added recently -- the
       picture is shown whole instead and the leftover frame is filled with a
       blurred copy of itself, so the card still reads full without cutting
       anything. */
    /* Fill when filling is cheap, whichever way the picture misses the card.

       The test used to be the DIRECTION of the miss: fill anything taller than
       the card, letterbox anything wider. That put a dead band under every
       photograph that was wider by a hair -- Angola misses by seven per cent and
       was still letterboxed. What matters is the COST, not the direction. A trim
       inside a seventh of the frame is not visible, so the card is filled; past
       that the picture is shown whole, which is what keeps the flat garment
       renders and the near-square shorts out of close-up. */
    var cover = loss <= FILL_COST;


    /* Drive the fit inline rather than through `data-fit`. The stylesheet only
       honours that attribute inside a handful of container classes, and the
       product rails are not among them — so a card that had been worked out as
       `cover` still rendered `contain`, and a landscape group shot sat in the
       middle of the card with a band of dead space above it. An inline value
       applies wherever the image happens to live.

       Where the picture is shown whole, it is anchored to the top: the leftover
       space then falls underneath it instead of splitting above and below,
       which is what stops the cards looking top-heavy. */
    if (cover) {
      img.setAttribute('data-fit', 'cover');
      img.style.setProperty('object-fit', 'cover', 'important');
      img.style.setProperty('object-position', 'center top', 'important');
      img.style.removeProperty('transform');
    } else {
      img.removeAttribute('data-fit');
      img.style.setProperty('object-fit', 'contain', 'important');
      /* A picture shown whole sits in the middle of the card. Anchoring it to
         the top puts the whole of the leftover space underneath it, which on a
         landscape frame reads as the picture having slipped upwards; split, it
         reads as a margin. */
      img.style.setProperty('object-position', 'center center', 'important');

      /* Landscape photographs are brought up to the Fashion Week Golfer, which
         is the card everyone agrees looks right. That one is 4734x5259 — a
         shade under the card's own shape — so `cover` trims about a sixth off
         it and the garment still reads. A true landscape frame is nowhere near
         the card's shape: filling one outright would throw away half its width
         and take the product with it, which is what made the City of Tshwane
         renders look like close-ups. So it is not filled — it is shown whole
         and then zoomed by the same sixth, clipped by the frame. More of the
         card is covered, and the garment survives. */
      if (LANDSCAPE_ZOOM > 1 && shot > 1.15) {
        img.style.setProperty('transform',
          'scale(' + Math.min(LANDSCAPE_ZOOM, shot / frame).toFixed(3) + ')', 'important');
        img.style.setProperty('transform-origin', 'center center', 'important');
      } else {
        img.style.removeProperty('transform');
      }
    }

    /* Behind a letterboxed picture, match its own backdrop so the frame does
       not show a slab of a different colour — several shoots are light grey. */
    box.style.removeProperty('background-color');
    if (box.__nyeletiCardBg) {
      box.__nyeletiCardBg.style.display = 'none';
    }
    img.__nyeletiFitDone = 1;
    return true;
  }

  /* Why the card fit kept coming back.

     Each card was decided once, on load, and a decision that could not be made
     was dropped in silence. That is fine for a grid that is in the document from
     the start, and wrong for the "You might also like" rail: it is built after
     load, inside a horizontal carousel, so at the moment its images finish
     loading the frame around them can still measure zero. decideFit found no
     box, returned, and the listener was `{ once: true }` — so those cards kept
     the stylesheet's `contain` for the life of the page, no matter how many
     times the rule itself was corrected.

     An unmeasured image is now kept and looked at again: on every load, when it
     scrolls into view, and on a few sweeps after load. It stops being watched
     only once it has actually been measured. */
  var fitWatcher = null;

  function watchFit(img) {
    if (!img.__nyeletiFitBound) {
      img.__nyeletiFitBound = 1;
      img.addEventListener('load', function () {
        if (decideFit(img) && fitWatcher) fitWatcher.unobserve(img);
      });
    }
    if (window.IntersectionObserver) {
      if (!fitWatcher) {
        fitWatcher = new IntersectionObserver(function (recs) {
          for (var i = 0; i < recs.length; i++) {
            if (decideFit(recs[i].target)) fitWatcher.unobserve(recs[i].target);
          }
        }, { rootMargin: '200px' });
      }
      fitWatcher.observe(img);
    }
  }

  function applyFits(root) {
    var imgs = (root || document).querySelectorAll(FIT_SEL);
    Array.prototype.forEach.call(imgs, function (img) {
      if (img.__nyeletiFitDone) return;
      if (!decideFit(img)) watchFit(img);
    });
  }

  /* ---------------------------------------------------------------------
     Personalisation on the partner ranges.

     The name and number only apply when the buyer asks for them, so those two
     fields stay out of the way until "Yes" is chosen. They are DISABLED while
     hidden, not merely hidden: a disabled control is not submitted, so an
     order without personalisation carries no empty "Name To Print" line to
     read past on the packing slip.
     ------------------------------------------------------------------- */
  function wirePersonalisation() {
    var blocks = document.querySelectorAll('[data-personalise]');
    Array.prototype.forEach.call(blocks, function (block) {
      if (block.__nyeletiPersonalise) return;
      block.__nyeletiPersonalise = true;

      var toggle = block.querySelector('[data-personalise-toggle]');
      var extra = block.querySelector('[data-personalise-extra]');
      if (!toggle || !extra) return;

      var fields = extra.querySelectorAll('input, select, textarea');

      function sync() {
        var on = toggle.value === 'Yes';
        extra.hidden = !on;
        Array.prototype.forEach.call(fields, function (f) {
          f.disabled = !on;
          if (!on) f.value = '';
        });
      }

      toggle.addEventListener('change', sync);
      sync();
    });
  }

  ready(function () {
    wireSearch();
    wirePersonalisation();
    applyFits();
    /* Cards arrive late: lazy images, the filter rail re-rendering the grid,
       and the home rails building their markup after load. */
    if (window.MutationObserver) {
      var mo = new MutationObserver(function (recs) {
        for (var i = 0; i < recs.length; i++) {
          if (recs[i].addedNodes.length) { applyFits(); return; }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
    window.addEventListener('resize', function () { applyFits(); });
    /* Backstop for anything that arrives without touching the observer — a rail
       whose markup is written in one go, or a carousel that only takes its
       height once its own script has run. */
    [300, 900, 2000, 4000].forEach(function (t) {
      setTimeout(function () { applyFits(); }, t);
    });
  });

  /* ---------------------------------------------------------------------
     Swatch -> the photograph of that colour.

     Variant images were never set in the admin, and the uploads are named by
     shoot rather than by colour, so name matching misses. Each photograph is
     reduced to its dominant garment colour and paired with the nearest swatch.
     --------------------------------------------------------------------- */
  function loadAnon(src) {
    return new Promise(function (res) {
      var im = new Image();
      // Reading pixels from a plain <img> taints the canvas; this does not.
      im.crossOrigin = 'anonymous';
      im.onload = function () { res(im); };
      im.onerror = function () { res(null); };
      im.src = src.split('?')[0] + '?width=200';
    });
  }

  function hsl(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2;
    var h = 0, s = 0, d = mx - mn;
    if (d) {
      s = l > 0.5 ? d / (2 - mx - mn) : d / (mx + mn);
      if (mx === r) h = ((g - b) / d + (g < b ? 6 : 0));
      else if (mx === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h *= 60;
    }
    return [h, s, l];
  }

  /* Straight RGB distance cannot separate a very dark green from black — the
     Men's Sports Shorts green swatch scored closer to the black pair than to
     the green one. Hue decides when both colours actually have some, and
     lightness decides when one of them is effectively neutral. */
  function distance(a, b) {
    var neutral = a[1] < 0.18 || b[1] < 0.18;
    if (neutral) {
      // One side is a black/white/grey: only lightness is meaningful, and a
      // saturation mismatch should still count against the pairing.
      return Math.abs(a[2] - b[2]) * 200 + Math.abs(a[1] - b[1]) * 120;
    }
    var dh = Math.abs(a[0] - b[0]);
    if (dh > 180) dh = 360 - dh;
    return dh * 0.8 + Math.abs(a[1] - b[1]) * 60 + Math.abs(a[2] - b[2]) * 60;
  }

  function dominant(img) {
    try {
      var W = 40, H = 40;
      var c = document.createElement('canvas');
      c.width = W; c.height = H;
      var cx = c.getContext('2d', { willReadFrequently: true });
      cx.drawImage(img, 0, 0, W, H);
      var d = cx.getImageData(0, 0, W, H).data;
      var corner = [d[0], d[1], d[2]];
      var acc = [0, 0, 0], n = 0;
      for (var y = 8; y < 34; y++) {
        for (var x = 8; x < 32; x++) {
          var o = (y * W + x) * 4;
          var r = d[o], g = d[o + 1], b = d[o + 2];
          // Skip the backdrop and blown highlights.
          if (Math.abs(r - corner[0]) + Math.abs(g - corner[1]) +
              Math.abs(b - corner[2]) < 60) continue;
          if (r > 242 && g > 242 && b > 242) continue;
          acc[0] += r; acc[1] += g; acc[2] += b; n++;
        }
      }
      return n ? [acc[0] / n, acc[1] / n, acc[2] / n] : null;
    } catch (e) { return null; }
  }

  ready(function swatches() {
    var root = document.querySelector('[data-product-root]');
    if (!root) return;
    var sw = root.querySelectorAll('[data-swatch]');
    var th = root.querySelectorAll('[data-product-thumb]');
    if (sw.length < 2 || th.length < 2) return;

    (async function () {
      var shots = [];
      for (var i = 0; i < th.length; i++) {
        var src = th[i].getAttribute('data-src');
        if (!src) continue;
        var im = await loadAnon(src);
        if (!im) continue;
        var dom = dominant(im);
        if (dom) shots.push({ src: src, dom: dom });
      }
      if (shots.length < 2) return;

      Array.prototype.forEach.call(sw, function (s) {
        var m = getComputedStyle(s).backgroundColor.match(/(\d+), (\d+), (\d+)/);
        if (!m) return;
        var want = hsl(+m[1], +m[2], +m[3]);
        var best = null, bestD = Infinity;
        shots.forEach(function (p) {
          var d = distance(want, hsl(p.dom[0], p.dom[1], p.dom[2]));
          if (d < bestD) { bestD = d; best = p; }
        });
        // Only claim a match when the photograph really is that colour.
        if (best && bestD < 90) s.setAttribute('data-colour-src', best.src);
      });

      /* Setting main.src directly does not hold: the gallery re-syncs the main
         image to its own active thumbnail straight after the click, so the
         colour lasted a frame and reverted. Clicking the matching thumbnail
         instead lets the theme perform the switch it already knows how to do,
         and nothing overwrites it. */
      function base(u) { return (u || '').split('/').pop().split('?')[0]; }

      root.addEventListener('click', function (e) {
        var s = e.target.closest && e.target.closest('[data-swatch]');
        if (!s) return;
        var want = base(s.getAttribute('data-colour-src'));
        if (!want) return;
        var match = null;
        Array.prototype.forEach.call(th, function (t) {
          if (base(t.getAttribute('data-src')) === want) match = t;
        });
        // After the theme's own handlers for this click have run.
        if (match) setTimeout(function () { match.click(); }, 0);
      }, true);
    })();
  });
})();
